import { ExtraPackageBoostType, ExtraPackageCampaignCategory } from "../const.mjs";
import { z } from "zod";
//#region src/payment/item/boost.ts
const extraPackageBoostSchema = z.object({
	type: z.enum(ExtraPackageBoostType),
	name: z.string(),
	displayName: z.string().optional(),
	percentage: z.number(),
	category: z.enum(ExtraPackageCampaignCategory).optional(),
	endTime: z.iso.datetime().optional()
});
const extraPackageValueSchema = z.object({
	tier: z.number(),
	value: z.number(),
	tierPercentage: z.number().optional(),
	creditsAfterBoosts: z.number(),
	extraPackageBoosts: z.array(extraPackageBoostSchema)
});
const extraPackageBoostItemSchema = z.object({
	id: z.string(),
	values: z.array(extraPackageValueSchema),
	boostNameBlacklist: z.array(z.string()).optional(),
	oneTimePurchase: z.boolean().optional(),
	monthlyPurchase: z.boolean().optional()
});
const pendingBoostSchema = z.object({
	boost: extraPackageBoostSchema,
	targetTier: z.number().optional()
});
//#endregion
export { extraPackageBoostItemSchema, extraPackageBoostSchema, extraPackageValueSchema, pendingBoostSchema };
